export default "__VITE_ASSET__CSXBc6Zg__"